<template>
    <div v-if="cardData && cardData.length > 0" class="ovy-auto">
        <ul>
            <li v-for="ticket in cardData" :key="ticket.id" class="ticket">
                <a :href="`/?_f=support_ticket&tid=${ticket.id}`" class="gray-100 p-2 br">
                    <!-- color status -->
                    <p class="fs-2 status my-1">
                        <span class="chip" :class="checkChip(ticket.step)"></span>
                        {{ $filters.capitalize(checkStatus(ticket.step)) }}
                    </p>
                    <!-- object -->
                    <p>{{ ticket.subject }}</p>
                    <!-- info date/ident/name of client concerned -->
                    <p class="fs-2 gray-60 my-1">
                        <span class="mr-3">{{
                            $filters.dateFormatter(ticket.updatedDate, 'SLASHED_DATE_TIME')
                        }}</span>
                        <span class="mr-3">#{{ ticket.ident }}</span>
                        <span>{{ ticket.thirdname }}</span>
                    </p>
                    <!-- if corp card, display "assigned at : " -->
                    <div v-if="context == 'ticket_corp'" class="fs-2 gray-60 my-1">
                        <p v-if="ticket.assigned">
                            {{
                                $l10n.__('Assigné à : %(staffname)s', {
                                    staffname: ticket.assigned,
                                })
                            }}
                        </p>
                        <p v-else>{{ $l10n.__('Non assigné') }}</p>
                    </div>
                </a>
            </li>
        </ul>
        <a :href="filterUrl(context)" class="link acenter dd mt-4">{{
            $l10n.__('Voir tous les tickets')
        }}</a>
    </div>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';

export default {
    mixins: [CardMixin],
    props: {
        context: {
            type: String,
            required: false,
            default: '',
        },
    },
    methods: {
        checkChip(status) {
            switch (status) {
                case 'active':
                    return 'chip-success';
                    break;

                case 'pending':
                    return 'chip-warning';
                    break;
            }
        },
        checkStatus(status) {
            switch (status) {
                case 'active':
                    return this.$l10n.__('Actif');
                    break;

                case 'pending':
                    return this.$l10n.__('En attente');
                    break;
            }
        },
        filterUrl(context) {
            var type = context == 'ticket_corp' ? 'all' : 'mine';
            return '/?_f=support_tickets&from=dashboard&filters%5Bassigned%5D=' + type;
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.ticket {
    a {
        display: block;

        &:hover {
            background-color: $primary-05;
            cursor: pointer;
        }
    }
}
</style>
